import { useRef, useState } from 'react'
import Image from '@ui/image'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBookOpenCover } from '@fortawesome/pro-solid-svg-icons/faBookOpenCover'
import { faFileArrowDown } from '@fortawesome/pro-solid-svg-icons/faFileArrowDown'
import FlipBook from '@components/flipbook/layout-01'
import {
  BoxLargeImgWrap,
  BoxLargeImgInner,
  BoxLargeImgMedia,
  BoxLargeImgContent,
  HeadingWrap,
  CategoryWrap,
  TextWrap,
  BoxCircleBtnWrap,
  BoxCircleBtnInner,
  BoxCircleBtn
} from './style'
import { downloadTexts as texts } from '@constants/general'
import { usePageContext } from '@context/PageContext'
import usePdfData from '@hooks/use-pdf-data'
import useIsMobile from '@hooks/use-is-mobile'

const BoxLargeImage = ({
  image,
  title,
  category,
  desc,
  path,
  className,
  layout,
  url,
  ...restProps
}) => {
  const [rerender, setRerender] = useState(0)

  const bookRef = useRef(null)
  const isMobile = useIsMobile()
  const pdfData = !isMobile ? usePdfData(path) : {}

  const { locale } = usePageContext()
  const localeTexts = texts[locale] || texts.de

  return (
    <BoxLargeImgWrap className={className} {...restProps}>
      <BoxLargeImgInner>
        {image?.src && (
          <BoxLargeImgMedia>
            <Image
              src={image.src.localFile || image.src}
              alt={image.src.alternativeText || title}
            />
          </BoxLargeImgMedia>
        )}
        <BoxLargeImgContent $layout={layout}>
          {title && (
            <HeadingWrap as="h5" $layout={layout}>
              {title}
            </HeadingWrap>
          )}
          {category && <CategoryWrap>{category}</CategoryWrap>}
          {desc && <TextWrap $layout={layout}>{desc}</TextWrap>}
          {url && (
            <>
              {!isMobile && (
                <BoxCircleBtnWrap
                  transform="translateX(-110%)"
                  onClick={() => bookRef.current?.setShow(true)}
                  aria-label={localeTexts.openFlipbook}
                >
                  <BoxCircleBtnInner>
                    <div className="middle-dot" />
                    <div className="middle-dot dot-2" />
                    <BoxCircleBtn>
                      <FontAwesomeIcon icon={faBookOpenCover} />
                    </BoxCircleBtn>
                  </BoxCircleBtnInner>
                </BoxCircleBtnWrap>
              )}
              <BoxCircleBtnWrap
                transform={!isMobile ? 'translateX(10%)' : 'translateX(-50%)'}
                href={`${url}`}
                download
                aria-label={localeTexts.pdf}
              >
                <BoxCircleBtnInner>
                  <div className="middle-dot" />
                  <div className="middle-dot dot-2" />
                  <BoxCircleBtn>
                    <FontAwesomeIcon icon={faFileArrowDown} />
                  </BoxCircleBtn>
                </BoxCircleBtnInner>
              </BoxCircleBtnWrap>
              {pdfData && (
                <FlipBook
                  key={rerender}
                  ref={bookRef}
                  pdfFile={pdfData}
                  url={url}
                  resetFlipBook={() => setRerender((prev) => prev + 1)}
                />
              )}
            </>
          )}
        </BoxLargeImgContent>
      </BoxLargeImgInner>
    </BoxLargeImgWrap>
  )
}

export default BoxLargeImage
